<div class="device-authorize-container">
  <div class="device-authorize-card">
    <div class="device-authorize-header">
      <h1>Authorize Device</h1>
    </div>

    <div *ngIf="!codeVerified && !isAuthorized" class="code-entry">
      <p class="instructions">Enter the code displayed on your TV or device to authorize sign-in.</p>

      <div class="code-input-wrapper">
        <input
          type="text"
          class="code-input"
          [value]="userCode"
          (input)="onCodeInput($event)"
          placeholder="XXXX-XXXX"
          maxlength="9"
          [disabled]="isVerifying"
        />
      </div>

      <button
        class="verify-button"
        (click)="verifyCode()"
        [disabled]="isVerifying || userCode.length < 9"
      >
        <i *ngIf="isVerifying" class="pi pi-spin pi-spinner"></i>
        <span *ngIf="!isVerifying">Continue</span>
        <span *ngIf="isVerifying">Verifying...</span>
      </button>

      <div *ngIf="errorMessage" class="error-message">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>
    </div>

    <div *ngIf="codeVerified && !isAuthorized" class="confirm-authorization">
      <div class="code-confirmed">
        <i class="pi pi-check-circle"></i>
        <p>Code verified: <strong>{{ userCode }}</strong></p>
      </div>

      <p class="confirm-instructions">
        Click the button below to authorize this device to sign in with your account.
      </p>

      <button
        class="authorize-button"
        (click)="authorizeDevice()"
        [disabled]="isAuthorizing"
      >
        <i *ngIf="isAuthorizing" class="pi pi-spin pi-spinner"></i>
        <span *ngIf="!isAuthorizing">Authorize Device</span>
        <span *ngIf="isAuthorizing">Authorizing...</span>
      </button>

      <button class="cancel-button" (click)="resetForm()" [disabled]="isAuthorizing">
        Cancel
      </button>

      <div *ngIf="errorMessage" class="error-message">
        <i class="pi pi-exclamation-circle"></i>
        <span>{{ errorMessage }}</span>
      </div>
    </div>

    <div *ngIf="isAuthorized" class="success-state">
      <i class="pi pi-check-circle"></i>
      <h2>Device Authorized!</h2>
      <p>You can now close this page. Your TV or device will sign in automatically.</p>
      <button class="done-button" (click)="resetForm()">Authorize Another Device</button>
    </div>
  </div>
</div>
